// removed by extract-text-webpack-plugin
module.exports = {"container":"region-summary-popup-module__container___2BGyB","paragraph":"region-summary-popup-module__paragraph___3hAoT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/region-summary-popup/region-summary-popup.module.scss
// module id = 1304
// module chunks = 0